// import { Component } from '@angular/core';
// import { RouterOutlet } from '@angular/router';

// @Component({
//   selector: 'app-root',
//   imports: [RouterOutlet],
//   templateUrl: './app.component.html',
//   styleUrl: './app.component.css',
// })
// export class AppComponent {
//   title = 'EPOSDeck RMS';
// }

import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { GrpcService } from './shared/services/grpc.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'EPOSDeck RMS';

  constructor(
    private grpcService: GrpcService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.reconnectGrpcAfterRefresh();
  }

  private reconnectGrpcAfterRefresh(): void {
    const token = localStorage.getItem('token');
    const storeCode = localStorage.getItem('StoreCode');

    if (!token || !storeCode) {
      console.log(
        'gRPC reconnect skipped: login token or store code is unavailable',
      );
      return;
    }

    console.log('Reconnecting gRPC after refresh for store:', storeCode);

    this.grpcService.connect(storeCode, (event: any) => {
      this.handleGrpcEvent(event);
    });
  }

  private handleGrpcEvent(event: any): void {
    if (!event) {
      return;
    }

    console.log('gRPC event received in AppComponent:', event);

    const eventType = String(
      event.type || event.transactionType || '',
    ).toUpperCase();

    switch (eventType) {
      case 'CONNECTED':
        console.log('gRPC connection established');
        return;

      case 'LOGOUT':
        this.handleForceLogout(
          event.message || 'You have been logged out from another device',
        );
        return;

      default:
        this.handleOtherGrpcEvent(event);
        return;
    }
  }

  private handleOtherGrpcEvent(event: any): void {
    console.log('Unhandled gRPC event:', event);

    // Printer, invoice and other transaction handling
    // can be added here later.
  }

  private handleForceLogout(message: string): void {
    console.error(message);

    this.grpcService.disconnect();

    localStorage.clear();

    this.router.navigate(['/auth']);
  }
}
